import React, { RefObject } from 'react';

import Icon from '3-components/Icon/Icon';

interface ButtonProps {
    href?: string,
    target?: string,
    btnSkin?: string,
    btnSize?: string,
    isDisabled?: boolean,
    onclick?: () => void,
    prefixIcon?: string,
    btnText?: string | React.ReactNode,
    suffixIcon?: string,
    btnCustomClass?: string,
    onlyIcon?: boolean,
    ref?: RefObject<HTMLButtonElement> | RefObject<HTMLAnchorElement>
}

const Button = (props: ButtonProps) => {
    const {
        href,
        target,
        btnSkin,
        btnSize,
        isDisabled,
        onclick,
        prefixIcon,
        btnText,
        suffixIcon,
        btnCustomClass,
        onlyIcon,
        ref
    } = props;

    // const aa = useRef()

    const buildClassname = () => {
        const skinClass = `btn-skin-${btnSkin ? btnSkin : '1'}`;
        const sizeClass = `btn-size-${btnSize ? btnSize : 'md'}`;
        const disabledClass = isDisabled ? 'btn-disabled' : '';

        return `btn ${skinClass} ${sizeClass} ${disabledClass} ${btnCustomClass ? btnCustomClass : ''} ${onlyIcon ? 'btn-only-icon' : ''}`;
    };

    return (
        <>
            {href && (
                <a href={href} target={target} className={buildClassname()} onClick={onclick} ref={ref as RefObject<HTMLAnchorElement>}>
                    {prefixIcon && (
                        <Icon icon={prefixIcon} />
                    )}
                    {btnText && (<span className="btn-text">{btnText}</span>)}
                    {suffixIcon && (
                        <Icon icon={suffixIcon} />
                    )}
                </a>
            )}
            {!href && (
                <button type="button" className={buildClassname()} onClick={onclick} ref={ref as RefObject<HTMLButtonElement>}>
                    {prefixIcon && (
                        <Icon icon={prefixIcon} />
                    )}
                    {btnText && (<span className="btn-text">{btnText}</span>)}
                    {suffixIcon && (
                        <Icon icon={suffixIcon} />
                    )}
                </button>
            )}
        </>
    );
};

export default Button;
